import { Button } from "@/components/ui/button";
import type { IPcpInfoResponse } from "@/hooks/use-pcpInfo";
import { usePcpInfo } from "@/hooks/use-pcpInfo";
import type Widget from "@/model/widget";
import WidgetCard from "@/pages/components/widget/widget-card";
import MyPcp from "@/pages/my-pcp";
import { CircleArrowRight } from "lucide-react";
import { useState } from "react";
import PcpCard from "../pcp-card";

type IPcpWidget = {
  widget: Widget;
};

const PcpWidget: React.FC<IPcpWidget> = ({ widget }) => {
  type PcpInfoCard = IPcpInfoResponse["results"][number];
  const [showPcpInfo, setShowPcpInfo] = useState(false);
  const pcpInfoQuery = usePcpInfo();

  const pcpWidgetData = pcpInfoQuery.data?.results?.slice(0, 2);

  const renderWidget = () => {
    return (
      <div className="flex w-full flex-col flex-wrap gap-4">
        {pcpWidgetData?.map((pcpInfo: PcpInfoCard) => (
          <PcpCard
            key={pcpInfo?.memberId}
            pcpName={pcpInfo?.name}
            firstName={pcpInfo?.firstName}
            lastName={pcpInfo?.lastName}
            visitDate={pcpInfo?.visitDate}
          />
        ))}
      </div>
    );
  };

  const viewAll = () => {
    setShowPcpInfo(!showPcpInfo);
  };

  const footerContent = (
    <Button variant="link" className="w-full hover:underline" onClick={viewAll}>
      View All <CircleArrowRight className="ml-1" />
    </Button>
  );

  return (
    <>
      <WidgetCard
        title={widget?.widgetDisplayName}
        footerContent={footerContent}
      >
        {renderWidget()}
      </WidgetCard>
      <MyPcp dialogOpen={showPcpInfo} setDialogOpen={setShowPcpInfo} />
    </>
  );
};

export default PcpWidget;
